<template>
  <v-form v-model="isValid">
    <div class="section-header text-center mb-2 mb-md-0">
      Ca să putem reveni cu o ofertă personalizată,
      <br />te rugăm să lași un număr de telefon
      <br />și te contactăm noi
    </div>
    <div class="d-flex flex-column align-center justify-center">
      <div class="mb-2 d-flex flex-column align-center">
        <v-subheader class="field-label text-center">
          {{ nameQuestion.text }}
        </v-subheader>
        <div>
          <v-text-field
            v-model="name"
            :rules="nameQuestion.rules"
            dense
            filled
            rounded
            solo
            flat
            class="text-input"
            @input="updateEvent"
          />
        </div>
      </div>
      <div class="mb-2 d-flex flex-column align-center">
        <v-subheader class="field-label text-center">
          {{ phoneQuestion.text }}
        </v-subheader>
        <div>
          <v-text-field
            v-model="phone"
            :rules="phoneQuestion.rules"
            dense
            filled
            rounded
            solo
            flat
            class="text-input"
            @input="updateEvent"
          />
        </div>
      </div>
      <!--      <div class="d-flex flex-column flex-md-row align-center">-->
      <!--        <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">-->
      <!--          {{ emailQuestion.text }}-->
      <!--        </v-subheader>-->
      <!--        <div>-->
      <!--          <div v-if="!isMobile" style="height: 22px;"></div>-->
      <!--          <v-text-field-->
      <!--            v-model="email"-->
      <!--            :rules="emailQuestion.rules"-->
      <!--            dense-->
      <!--            filled-->
      <!--            rounded-->
      <!--            solo-->
      <!--            flat-->
      <!--            class="text-input"-->
      <!--            @input="updateEvent"-->
      <!--          />-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </v-form>
</template>

<script>
import { cascoConfirmationQuestions } from '@/_utils/static-data';

export default {
  name: 'CompleteContactForm',
  data() {
    return {
      name: null,
      phone: null,
      email: 'it@bancassurance.md',
      isValid: false
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 961;
    },
    nameQuestion() {
      return this.getQuestionById(1);
    },
    phoneQuestion() {
      return this.getQuestionById(2);
    },
    emailQuestion() {
      return this.getQuestionById(3);
    }
  },
  methods: {
    getQuestionById(id) {
      return cascoConfirmationQuestions(id)?.[0];
    },
    updateEvent() {
      setTimeout(() => {
        this.$emit('updateData', {
          data: [
            {
              questionText: this.nameQuestion.text,
              text: this.name,
              value: 'name'
            },
            {
              questionText: this.phoneQuestion.text,
              text: this.phone,
              value: 'phone'
            },
            {
              questionText: this.emailQuestion.text,
              text: this.email,
              value: 'email'
            }
          ],
          isValid: this.isValid
        });
      });
    }
  }
};
</script>

<style scoped>
.section-header {
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
}
.text-input, .dropdown-input {
  border-radius: 4px;
  width: 355px;
}
.text-input ::v-deep input, .dropdown-input ::v-deep .v-select__slot input {
  border: none;
}
@media screen and (max-width: 600px) {
  .text-input, .dropdown-input {
    width: 100%;
    min-width: 260px;
  }
}
</style>
